import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationType } from './notification-banner.model';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent } from '../buttons/button/button.component';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

const ColorSchemes = {
  danger: {
    subtle: {
      backgroundClass: 'bg-red-050',
      iconColorClass: 'text-red-600',
      textColorClass: 'text-neutral-800',
      iconClass: 'fa-circle-exclamation',
    },
    bold: {
      backgroundClass: 'bg-red-600',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
      iconClass: 'fa-circle-exclamation',
    },
  },
  info: {
    subtle: {
      backgroundClass: 'bg-blue-050',
      iconColorClass: 'text-secondary-light',
      textColorClass: 'text-neutral-800',
      iconClass: 'fa-circle-info',
    },
    bold: {
      backgroundClass: 'bg-secondary-light',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
      iconClass: 'fa-circle-info',
    },
  },
  warning: {
    subtle: {
      backgroundClass: 'bg-yellow-050',
      iconColorClass: 'text-yellow-300',
      textColorClass: 'text-neutral-800',
      iconClass: 'fa-circle-exclamation',
      closeBtnColor: 'neutral',
    },
    bold: {
      backgroundClass: 'bg-yellow-200',
      iconColorClass: 'text-neutral-700',
      textColorClass: 'text-neutral-800',
      iconClass: 'fa-circle-exclamation',
      closeBtnColor: 'neutral',
    },
  },
  neutral: {
    subtle: {
      backgroundClass: 'bg-neutral-010',
      iconColorClass: 'text-neutral-600',
      textColorClass: 'text-neutral-800',
      iconClass: '',
    },
    bold: {
      backgroundClass: 'bg-neutral-500',
      iconColorClass: 'text-white',
      textColorClass: 'text-white',
      iconClass: '',
    },
  },
};

@Component({
  selector: 'mwe-notification-banner',
  imports: [CommonModule, TranslatePipe, ButtonComponent, SafeHtmlPipe],
  templateUrl: './notification-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationBannerComponent {
  text = input.required<string>();
  type = input.required<NotificationType>();
  emphasis = input.required<'bold' | 'subtle'>();
  iconClass = input<string>();
  isClosable = input<boolean>(false);
  isVisible = signal(true);

  readonly closeClick = output();

  colorScheme = computed(() => {
    return ColorSchemes[this.type()][this.emphasis()];
  });

  close(): void {
    this.isVisible.set(false);
    this.closeClick.emit();
  }
}
